import { Card } from "@/components/ui/card";
import { Skeleton } from "../ui/skeleton";

interface SkeletonCardsMobileProps {
  columnsCount: number;
  cardsCount?: number;
}

export default function SkeletonCardsMobile({
  columnsCount,
  cardsCount = 5,
}: SkeletonCardsMobileProps) {
  return (
    <div className="flex flex-col flex-1 min-h-[40dvh]">
      <div className="flex-1 min-h-0 overflow-y-auto space-y-3 pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none] [-webkit-overflow-scrolling:touch]">
        {Array.from({ length: cardsCount }).map((_, index) => (
          <Card key={index} className="p-4 animate-pulse bg-card">
            <div className="space-y-3">
              {/* Título skeleton */}
              <Skeleton className="h-6  rounded w-3/4 mb-3" />
              <Skeleton className="h-px  mb-3" />

              {/* Campos skeleton */}
              <div className="space-y-2">
                {Array.from({ length: Math.max(columnsCount - 1, 1) }).map(
                  (_, fieldIndex) => (
                    <div
                      key={fieldIndex}
                      className="flex items-center justify-between py-1"
                    >
                      <Skeleton className="h-4  rounded w-1/3" />
                      <Skeleton className="h-4  rounded w-1/2" />
                    </div>
                  ),
                )}
              </div>

              {/* Botones skeleton */}
              <div className="flex gap-2 pt-3">
                <Skeleton className="h-8  rounded flex-1" />
                <Skeleton className="h-8  rounded flex-1" />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
